import { DepotBin } from "depot/depot-bin";
import { DeviceDetailDataTypes, DeviceValueTypes } from "pages/Devices/devices.config";

export interface AllSoftwareTypes {
  swVersion: string;
}

export interface softwareRecordTypes {
  autoUpdated: boolean;
  autoupdatedVersion: string;
  clientRequested: string;
  deviceConnectedTime: string;
  deviceSoftware: string;
  eligibleForUpdate: boolean;
  retryCount: number;
  serialNumber: string;
  updatedTime: string;
}

export const currentSoftwareDepot = new DepotBin<string>("");

export const allSoftwareDepot = new DepotBin<AllSoftwareTypes[]>([]);

export const softwareRecordsDepot = new DepotBin<softwareRecordTypes[]>([]);

export const serialSearchResultDepot = new DepotBin<softwareRecordTypes[]>([]);

export const dateSearchResultDepot = new DepotBin<softwareRecordTypes[]>([]);

export const versionSearchResultDepot = new DepotBin<softwareRecordTypes[]>([]);

// Manual Update

export const deviceDetailDepot = new DepotBin<any>({});

export const currentSoftwareManualDepot = new DepotBin<string>("");

export const pendingActionsDepot = new DepotBin<DeviceDetailDataTypes[]>([]);
